/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {TimerDirective as ɵa} from './lib/timer.directive';